import React from "react";
import styled from "@emotion/styled";
import { ClearedStyleRouterLink } from "@modules/Components";

const LinkSpan = styled.span`
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  text-align: center;
  color: ${props => props.setColor};
  display: flex;
  width: 100%;
  height: 67px;
  justify-content: center;
  align-items: center;
  position: relative;

  @media (max-width: 1400px) {
    font-size: 15px;
  }
`;

const Link = styled(ClearedStyleRouterLink)`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${props => props.to.style.color};
`;

const SideBar = styled.div`
  position: absolute;
  left: 0;
  height: 32px;
  width: 3px;
  background-color: rgb(18, 178, 234);
  border-radius: 0px 100px 100px 0px;
`;

const Span = styled.span`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const SelectOrderTypePanel = ({
  route,
  text,
  currentPage,
  action,
  display,
  routerLink
}) => (
  <LinkSpan
    onClick={action}
    setColor={display === route ? "#1f2021" : "#777984"}
  >
    {display === route && <SideBar />}
    {routerLink && !currentPage.includes(route) ? (
      <Link
        to={{
          pathname: `/account/${route}/`,
          style: {
            color: display === route ? "#1f2021" : "#777984"
          }
        }}
      >
        {text}
      </Link>
    ) : (
      <Span>{text}</Span>
    )}
  </LinkSpan>
);

export default SelectOrderTypePanel;
